import type { QueryClient } from '@tanstack/react-query';

/** Fire-and-forget query prefetch; errors are swallowed so loaders never block navigation. */
export function prefetchQueryNonBlocking(
  queryClient: QueryClient,
  // queryOptions() return types are wider than FetchQueryOptions; accept the concrete options object.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any,
): void {
  queryClient.prefetchQuery(options).catch(() => undefined);
}
